import { z } from 'zod';
import { arrayToNonEmptyArray } from './array-to-non-empty-array';
import { NachversandKind } from '@prisma/client';

export const nachversandKindZodEnum = () =>
  z
    .enum(arrayToNonEmptyArray(Object.values(NachversandKind)))
    .transform(
      (value) =>
        NachversandKind[
          value as keyof typeof NachversandKind
        ] as NachversandKind,
    );
